import { render } from "./TestDepoSetup.vue?vue&type=template&id=7e76e3ae&scoped=true"
import script from "./TestDepoSetup.vue?vue&type=script&lang=js"
export * from "./TestDepoSetup.vue?vue&type=script&lang=js"

import "./TestDepoSetup.vue?vue&type=style&index=0&id=7e76e3ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e76e3ae"]])

export default __exports__